import './Breadcrumbs.css';
import React from 'react';

function Breadcrumbs(props) {
  return (
      <div className={`breadcrumbs ${props.className ? props.className : ''}`}>
        <ul className="breadcrumbs-list">
          {
            props.breadcrumbs && Array.isArray(props.breadcrumbs) ?
                props.breadcrumbs.map((breadcrumb, index) => {
                  return index + 1 === props.breadcrumbs.length ?
                      <li key={breadcrumb.key}>{breadcrumb.title}</li> :
                      <li key={breadcrumb.key}>
                        <a href={breadcrumb.url}
                           title={breadcrumb.title}>{breadcrumb.title}</a>
                      </li>;
                }) :
                <></>
          }
        </ul>
      </div>
  );
}

export default Breadcrumbs;